import styles from './Social.module.scss';
/**
 * Render Corporate
 *
 * @return {Element} Corporate component
 */
export default function Corporate() {
  return (
    <div className={styles.social}>
      <img
        className={styles.social__logo}
        src="https://i.cdn.turner.com/cnn/.element/img/4.0/logos/cnn_logo_badge.png"
        alt="CNN Logo Badge"
      />
      <div>
        <span>Follow CNN</span>
        <ul>
          <li>
            <a href="https://www.facebook.com/cnn/">
              <svg
                className="facebook-icon"
                viewBox="0 0 64 64"
                fill=""
                xmlns="https://www.w3.org/2000/svg"
                aria-hidden="false"
              >
                <path d="M56,5.1H8c-1.6,0-3,1.4-3,3v48.8c0,1.7,1.3,3,3,3h25.9V38.7h-7v-8.3h7v-6.1 c0-7.1,4.3-10.9,10.5-10.9c3,0,5.9,0.2,6.7,0.3v7.7h-4.7c-3.4,0-4.1,1.6-4.1,4v5h8.1l-1,8.3h-7v21.2H56c1.6,0,3-1.4,3-3V8.1 C59,6.4,57.7,5.1,56,5.1"></path>
              </svg>
            </a>
          </li>
          <li>
            <a href="https://twitter.com/CNN">
              {' '}
              <svg
                className="twitter-icon"
                viewBox="0 0 64 64"
                fill=""
                xmlns="https://www.w3.org/2000/svg"
                aria-hidden="false"
              >
                <path d="M60,15.2c-2.1,0.9-4.3,1.5-6.6,1.7c2.4-1.4,4.2-3.6,5.1-6.1c-2.2,1.3-4.7,2.2-7.3,2.7 c-2.1-2.2-5.1-3.5-8.4-3.5c-6.3,0-11.5,5-11.5,11.1c0,0.9,0.1,1.7,0.3,2.5C22,23.2,13.6,18.8,7.9,12c-1,1.6-1.6,3.5-1.6,5.6 c0,3.9,2,7.3,5.1,9.2c-1.9-0.1-3.7-0.6-5.2-1.4v0.1c0,5.4,4,9.9,9.2,10.9c-1,0.3-2,0.4-3,0.4c-0.7,0-1.5-0.1-2.2-0.2 c1.5,4.4,5.7,7.6,10.7,7.7c-3.9,3-8.9,4.8-14.3,4.8c-0.9,0-1.8-0.1-2.7-0.2c5.1,3.2,11.1,5,17.6,5c21.1,0,32.7-16.9,32.7-31.6 c0-0.5,0-1,0-1.4C56.5,19.4,58.5,17.4,60,15.2"></path>
              </svg>
            </a>
          </li>
          <li>
            <a href="https://instagram.com/cnn">
              <svg
                viewBox="0 0 64 64"
                fill=""
                xmlns="https://www.w3.org/2000/svg"
                aria-hidden="false"
              >
                <path d="M47,13.2c-1.9,0-3.5,1.6-3.5,3.6s1.6,3.6,3.5,3.6s3.5-1.6,3.5-3.6S49,13.2,47,13.2 L47,13.2z M31.9,23c-5.1,0-9.3,4.3-9.3,9.5s4.2,9.5,9.3,9.5s9.3-4.3,9.3-9.5S37,23,31.9,23L31.9,23z M31.9,46.7 c-7.7,0-14-6.4-14-14.2s6.3-14.2,14-14.2s14,6.4,14,14.2S39.6,46.7,31.9,46.7L31.9,46.7z M15.7,8.8c-3.9,0-7,3.2-7,7.1v33.2 c0,3.9,3.1,7.1,7,7.1h32.7c3.9,0,7-3.2,7-7.1V15.9c0-3.9-3.1-7.1-7-7.1C48.4,8.8,15.7,8.8,15.7,8.8z M48.3,60.9H15.7 C9.2,60.9,4,55.6,4,49.1V15.9C4,9.4,9.2,4.1,15.7,4.1h32.7C54.8,4.1,60,9.4,60,15.9v33.2C60,55.6,54.8,60.9,48.3,60.9L48.3,60.9z"></path>
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
